import { ExitIcon } from '@/assets/icons/exitIcon';
import { HamburgerIcon } from '@/assets/icons/hamburgerIcon';
import { UserIcon } from '@/assets/icons/userIcon';
import React, { useState, useRef, useEffect } from 'react';

interface UserDropdownProps {
  userName?: string;
  isOneMoreRole?: boolean;
  onLogout?: () => void;
  onGoHome?: () => void;
}

export const UserDropdown: React.FC<UserDropdownProps> = ({
  userName = 'Juan Perez',
  onLogout,
  onGoHome,
  isOneMoreRole = false,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  return (
    <div className="relative inline-block text-left min-w-[150px]" ref={dropdownRef}>

      <button
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        aria-haspopup="true"
        className="flex items-center gap-3 px-4 py-2.5 md:px-6 md:py-3 border-2 border-bright-blue-700 rounded-full text-brand-cyan-600 hover:bg-brand-cyan-600/5 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-brand-cyan-600 
        focus:ring-offset-2 cursor-pointer w-full items-center"
      >

        <UserIcon />

        <span className="font-semibold text-sm md:text-base whitespace-nowrap">
          {userName}
        </span>

        <HamburgerIcon className='mt-1'/>
      </button>

      {isOpen && (
        <div className="absolute right-0 mt-3 w-full origin-top-right rounded-xl bg-white border border-brand-cyan-100 shadow-lg ring-1 ring-brand-cyan-100 ring-opacity-5 focus:outline-none z-50 animate-in fade-in 
        slide-in-from-top-1 duration-100">
          <div className="py-1" role="menu" aria-orientation="vertical">
            {isOneMoreRole && (
              <button
                onClick={() => {
                  if (onGoHome) onGoHome();
                  setIsOpen(false);
                }}
                className="flex w-full items-center px-4 py-2.5 text-sm text-gray-700 hover:bg-brand-cyan-400/10 transition-colors duration-150 text-left 
              border-none bg-transparent cursor-pointer border-b border-gray-200 border-solid text-black-600 font-medium text-sm"
                role="menuitem"
              >
                Ir al inicio
              </button>
            )}
            <button
              onClick={() => {
                if (onLogout) onLogout();
                setIsOpen(false);
              }}
              className="flex w-full items-center px-4 py-2.5 text-sm hover:bg-brand-cyan-400/10 transition-colors duration-150 text-left 
              border-none bg-transparent cursor-pointer text-red-700 font-roboto font-medium text-sm"
              role="menuitem"
            >
              <ExitIcon />
              <span className='ml-2'>Cerrar Sesión</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
